import { render } from "./ImageGalleryModel.vue?vue&type=template&id=686b2ae2"
import script from "./ImageGalleryModel.vue?vue&type=script&lang=js"
export * from "./ImageGalleryModel.vue?vue&type=script&lang=js"

import exportComponent from "D:\\MY PROJECTS\\Vue 3 Project\\MarriageBeauroWeb\\marriage_beauro_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__